import React from "react";

// Badge de SLA de resolução por chamado. O status vem do backend
// (utils/sla.ticket_sla, já em horário comercial). Não renderiza nada
// quando não há política aplicável ou o chamado foi cancelado.
const MAP = {
  no_prazo: { label: "No prazo", cls: "bg-emerald-100 text-emerald-700" },
  em_risco: { label: "Em risco", cls: "bg-amber-100 text-amber-700" },
  violado: { label: "SLA violado", cls: "bg-red-100 text-red-700" },
  cumprido: { label: "SLA cumprido", cls: "bg-emerald-100 text-emerald-700" },
};

const SlaBadge = ({ status, className = "" }) => {
  const cfg = MAP[status];
  if (!cfg) return null; // sem_politica / cancelado / desconhecido
  return (
    <span className={`inline-flex px-2 py-0.5 rounded-full text-[11px] font-semibold ${cfg.cls} ${className}`}>
      {cfg.label}
    </span>
  );
};

export default SlaBadge;
